// src/components/ui/ContentApprovalWorkflow.jsx
import {
    Delete as DeleteIcon,
    ArrowDownward as MoveDownIcon,
    ArrowUpward as MoveUpIcon,
    Person as PersonIcon
} from '@mui/icons-material';
import {
    alpha,
    Avatar,
    Box,
    IconButton,
    Paper,
    Typography,
    useTheme
} from '@mui/material';
import React from 'react';
import { Draggable } from '@hello-pangea/dnd';


const WorkflowStepItem = ({ step, index, onEdit, onDelete, onMoveUp, onMoveDown, isFirst, isLast }) => {
    const theme = useTheme();
    
    return (
      <Draggable draggableId={`step-${index}`} index={index}>
        {(provided) => (
          <Box
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            sx={{ mb: 2 }}
          >
            <Paper 
              sx={{ 
                p: 2, 
                display: 'flex', 
                alignItems: 'center', 
                bgcolor: alpha(theme.palette.primary.main, 0.05),
                borderLeft: `4px solid ${theme.palette.primary.main}`,
              }}
            >
              <Box sx={{ mr: 2 }}>
                <Avatar 
                  sx={{ 
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                  }}
                >
                  {index + 1}
                </Avatar>
              </Box>
              
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="subtitle1">
                  {step.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Approver: {step.assignedTo?.name || 'Not assigned'}
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex' }}>
                {!isFirst && (
                  <IconButton onClick={() => onMoveUp(index)} size="small">
                    <MoveUpIcon />
                  </IconButton>
                )}
                
                {!isLast && (
                  <IconButton onClick={() => onMoveDown(index)} size="small">
                    <MoveDownIcon />
                  </IconButton>
                )}
                
                <IconButton onClick={() => onEdit(index)} size="small">
                  <PersonIcon />
                </IconButton>
                
                <IconButton onClick={() => onDelete(index)} size="small" color="error">
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Paper>
          </Box>
        )}
      </Draggable>
    );
  };

  export default WorkflowStepItem